var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":_vm.$t('common.button.back'),"left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}},[_c('van-icon',{attrs:{"slot":"right","name":"wap-home-o"},slot:"right"})],1),_c('app-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }